<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.orderStatus === 'F' ? 'warning' : 'light'"
        >
          {{ row.v_orderStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.orderCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_print') || '打印清单'"
            placement="top"
            v-if="allow('P')"
          >
            <i
              class="el-icon-printer tool-btn"
              @click="printCheckList(row.orderCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '评审'"
            placement="top"
            v-if="allow('R')"
          >
            <i
              class="el-icon-s-check tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.orderCode },
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <PrintDialog
      :visible.sync="printDialogOptions.visible"
      :orderCode="printDialogOptions.orderCode"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import PrintDialog from '../print-dialog'
export default {
  mixins: [TableAutoHeight],
  components: { PrintDialog },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      printDialogOptions: {
        visible: false,
        orderCode: '',
      },
    }
  },
  methods: {
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'order-orderReview-detail',
        params: { ...params, pageType },
      })
    },
    printCheckList(orderCode) {
      this.printDialogOptions = {
        visible: true,
        orderCode,
      }
    },
  },
}
</script>
